import { render } from "./UploadCV.vue?vue&type=template&id=ae9daf68"
import script from "./UploadCV.vue?vue&type=script&lang=js"
export * from "./UploadCV.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__